<template>
  <v-layout
    align-center
    justify-center
  >
    <v-flex
      xs12
      sm8
      md6
    >
      <v-card class="elevation-12">
        <v-form v-model="login_data" ref="login_ref">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Inicio de sesión ONIGIES</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert 
              type="error"
              :value="alert"
              border="bottom"
              transition="scale-transition"
            >
              Usuario o contraseña incorrectas
            </v-alert>
            <v-text-field
              label="Nombre de usuario"
              name="username"
              prepend-icon="person"
              type="text"
              v-model="username"
              :rules="user_name_rules"
            ></v-text-field>
            <v-text-field
              id="password"
              label="Contraseña"
              @keyup.enter="login"
              name="password"
              prepend-icon="lock"
              type="password"
              v-model="password"
              :rules="password_rules"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="login()">Iniciar Sesión</v-btn>
            <!--<v-btn @click="login()" color="">IES</v-btn>
            <v-btn @click="login()" color="">Revisor</v-btn>-->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>        
  </v-layout>
</template>

<script>


export default {
  name: 'Login',
  components: {
    
  },
  data(){
    return {
      alert: false,
      login_data: undefined,
      username: undefined,
      password: undefined,
      user_name_rules:[v =>  !!v || 'Es necesario agregar un usuario'],
      password_rules:[v =>  !!v || 'Es necesario agregar una contraseña'],
    }
  },
  methods:{
    login(is_IES) {
      if(this.$refs.login_ref.validate()){
        this.$store.dispatch('LOGIN', {username: this.username, 
          password : this.password})
          .catch(err =>{
            this.alert = true;
            this.password= "";
            console.log(err)
            }
          );
      }

      /*
      if (is_IES)
        this.$store.dispatch('HAS_LOGGED', {user_name: 'UNAM', ies_id : 1, 
          token: 'c8c63a7c1c46f0083d44d2d1af3d34bd1f6f786e'})
      else
        this.$store.dispatch('HAS_LOGGED', {user_name: 'Ricardo', 
          token: 'c8c63a7c1c46f0083d44d2d1af3d34bd1f6f786e'})
      */
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
